import BookmarkButton from './BookmarkButton';

export default BookmarkButton;
export * from './types';
export { BookmarkButton };
